export { default, OneTrustLink, OneTrustScripts } from './OneTrust';
